module.exports = __webpack_public_path__ + "static/media/CONDITIONS_GENERALES_Immo.c6189346.pdf";